module.exports = __webpack_public_path__ + "static/nie-32cac7ab4724d992b8eafa6f7f5b85e9.png";